import React from 'react';
import s from './styles.module.css';
import {useTranslation} from "react-i18next";

const ConfirmModal = ({ isOpen, onClose, onConfirm, text }) => {
    const {t} = useTranslation();
    if (!isOpen) return null;

    return (
        <div className={s.overlay}>
            <div className={s.modal}>
                <p className={s.text}>{text}</p>

                <div className={s.actions}>
                    <button
                        className={`${s.button} ${s.cancel}`}
                        onClick={onClose}
                    >
                        {t('no')}
                    </button>

                    <button
                        className={`${s.button} ${s.confirm}`}
                        onClick={onConfirm}
                    >
                        {t('yes')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
